import FuxHTTP from "../../../lib/FuxFramework/FuxHTTP";
import APIConfig from "../../APIConfig";
import AuthAPI from "../../AuthAPI";


export const _Album = {
    pagination: cursor => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url(`/user/module-photo-albums/pagination`),
            {
                token: AuthAPI.getUserAccessToken(),
                cursor: cursor,
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    getFullAlbumInfo: event_album_id => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url(`/user/module-photo-albums/get-full-album-info`),
            {
                token: AuthAPI.getUserAccessToken(),
                event_album_id: event_album_id,
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    save: event => {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url(`/user/module-photo-albums/save`),
            event,
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    delete: event_album_id => {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url(`/user/module-photo-albums/delete`),
            {
                token: AuthAPI.getUserAccessToken(),
                event_album_id: event_album_id,
            },
            FuxHTTP.RESOLVE_MESSAGE,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    requestPhotoDownload: event_album_id => {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url(`/user/module-photo-albums/request-photos-download`),
            {
                token: AuthAPI.getUserAccessToken(),
                event_album_id: event_album_id,
            },
            FuxHTTP.RESOLVE_MESSAGE,
            FuxHTTP.REJECT_MESSAGE
        );
    }
}
